/** Éléments partagés entre le panneau de signalement et l'onglet suivi. */

export type PanelTab = "report" | "tracking";

export function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

interface TabBarProps {
  active: PanelTab;
  onChange: (tab: PanelTab) => void;
  /** Bugs à valider + commentaires non lus — badge sur l'onglet suivi. */
  badgeCount: number;
}

export function TabBar({ active, onChange, badgeCount }: TabBarProps) {
  return (
    <div className="bw-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={active === "report"}
        className={"bw-tab" + (active === "report" ? " bw-tab-active" : "")}
        onClick={() => onChange("report")}
      >
        Signaler un bug
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === "tracking"}
        className={"bw-tab" + (active === "tracking" ? " bw-tab-active" : "")}
        onClick={() => onChange("tracking")}
      >
        Suivi des bugs
        {badgeCount > 0 && <span className="bw-tab-badge">{badgeCount}</span>}
      </button>
    </div>
  );
}

export function StatusPill({ status, label }: { status: string; label: string }) {
  return <span className={`bw-pill bw-st-${status}`}>{label}</span>;
}

/** Date relative en français : « à l'instant », « il y a 3 j »… */
export function relativeDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const seconds = Math.round((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return "à l'instant";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `il y a ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `il y a ${hours} h`;
  const days = Math.round(hours / 24);
  if (days < 30) return `il y a ${days} j`;
  return date.toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
}

export function fullDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
